import React from "react";
import { Box, Button } from "@mui/material";
import PropTypes from "prop-types";

export default function AppViewHeader(props) {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="flex-end"
      flexDirection={{
        xs: "column",
        sm: "row"
      }}
      mb={4}
      mt={4}
    >
      {props.showAddButton && (
        <Button
          variant="contained"
          color="primary"
          onClick={props.onAddAppClick}
        >
          Add an App
        </Button>
      )}
    </Box>
  );
}

AppViewHeader.propTypes = {
  showAddButton: PropTypes.bool,
  onAddAppClick: PropTypes.func
};
